<template>
  <div class="machine-user">
    <search-user-machine
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      v-on:batchManage="batchManage"
      v-on:recoverMachine="recoverMachine"
      :selectList="selectList"
      :search="search"
      :yesNo="yesNo"
      :allColumnsList="allColumnsList"
      @handlerChangeColumns="handlerChangeColumns"
    >
    </search-user-machine>
    <edit-user-machine
      :dialogUserMachine="dialogUserMachine"
      :machineGroup="machineGroup"
      :yesNo="yesNo"
      :deviceMode="modeList"
      v-on:cancel="cancel"
      :userEquipment="userEquipment"
    >
    </edit-user-machine>
    <config-user-machine
      :deviceMode="modeList"
      :visible.sync="dialogConfigMachine"
      :yesNo="yesNo"
      v-on:cancel="configCancel"
      :userEquipment="ConfigSubmit"
      :biaoshi="false"
      :ageDevice="ageDevice"
      :feelLock="feelLock"
      :ageType="ageType"
      :priorityMode="priorityMode"
      :IdcardCountry="IdcardCountry"
    />
    <open-door-line
      :show="showOpenDoorLine"
      :userEquipment="openDoorMachine"
      @close="handlerCloseOpenDoorLine"
      @refresh="currentChange(page.pageIndex)"
    ></open-door-line>
    <user-machine-maps
      :userEquipment="userEquipment"
      v-on:mapsCancel="mapsCancel"
      v-on:addressUpdated="handleAddressUpdated"
      :dialogMachineMaps="dialogMachineMaps"
    >
    </user-machine-maps>
    <payment
      :payment="payment"
      :yesNo="yesNo"
      :shuaKaQi="shuaKaQi"
      v-on:cancelPayment="cancelPayment"
      :dialogPayment="dialogPayment"
    >
    </payment>
    <advert-config-dialog
      :visible="dialogAdvertConfig"
      mode="device"
      :equipment-no="advertConfigMachine.equipmentNo"
      :target-name="advertConfigMachine.equipmentName"
      @close="handleAdvertConfigClose"
    ></advert-config-dialog>
    <el-dialog
      :title="$t('machineUser.openDoorQrCode')"
      :visible.sync="showOpenDoorQrCode"
      width="30%"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div style="display: flex; justify-content: center; align-items: center">
        <el-image
          style="width: 300px; height: 300px"
          fit="contain"
          v-loading="showOpenDoorQrLoading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          :src="openDoorQrCode"
        >
        </el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showOpenDoorQrCode = false">{{ $t("common.close") }}</el-button>
      </div>
    </el-dialog>
    <div class="table vue-padding">
      <el-table
        ref="machineTable"
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :row-class-name="tableRowClassName"
        :data="userMachineList"
        style="width: 100%"
        :border="true"
        row-key="id"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column :selectable="selectable" type="selection" width="40" :align="'center'"></el-table-column>
        <el-table-column
          fixed="left"
          prop="equipmentNo"
          :label="$t('machineUser.equipmentNo')"
          width="140"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          fixed="left"
          prop="locale"
          :label="$t('machineUser.address')"
          width="200"
          :align="'center'"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.locale">{{ cleanAddress(scope.row.locale) }}</span>
            <el-link v-else type="danger" @click="openAddressDialog(scope.row)"> Click here to Add Address </el-link>
          </template>
        </el-table-column>
        <el-table-column
          v-if="nowAddColumns.includes('userName')"
          prop="userName"
          :label="$t('machineUser.userName')"
          width="200"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="teamName"
          :label="$t('machineUser.userMachineGroupName')"
          width="140"
          :align="'center'"
          sortable="custom"
        >
          <template #default="scope">
            {{ scope.row.userEquipmentTeam && scope.row.userEquipmentTeam.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('machineUser.name')"
          width="150"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="mqState"
          :label="$t('machineUser.online')"
          width="90"
          :align="'center'"
          sortable="mqState"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.mqState == 1">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-image style="width: 10px; height: 10px" :src="require('_as/zaixian.png')" fit="fill"></el-image>
                <div style="margin-left: 5px; color: rgb(103, 194, 58); font-size: 13px">
                  {{ $t("machineUser.onlinelabel1") }}
                </div>
              </div>
            </template>

            <template v-else-if="scope.row.mqState == 0">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-image style="width: 10px; height: 10px" :src="require('_as/lixian.png')" fit="fill"></el-image>
                <div style="margin-left: 5px; color: #f56c6c; font-size: 13px">
                  {{ $t("machineUser.onlinelabel2") }}
                </div>
              </div>
            </template>
            <template v-else-if="!scope.row.mqState">
              <div style="display: flex; justify-content: center; align-items: center">
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background-color: #dcdfe6;
                    border-radius: 100%;
                    border: 2px solid #909399;
                  "
                ></div>
                <div style="margin-left: 5px; font-size: 13px">
                  {{ $t("machineUser.onlinelabel3") }}
                </div>
              </div>
            </template>
          </template>
        </el-table-column>

        <el-table-column
          v-if="nowAddColumns.includes('enableStatus')"
          prop="enableStatus"
          :label="$t('machineUser.enableStatus')"
          :formatter="enableStatus"
          width="80"
          :align="'center'"
        ></el-table-column>

        <el-table-column fixed="right" :label="$t('common.operate')" min-width="360" :align="'center'">
          <template slot-scope="scope">
            <template v-if="scope.row.isTransfer === 0">
              <div style="display: flow-root">
                <div class="open-door-actions">
                  <template v-if="scope.row.isTransferNew == 1 && !isWarehouseAccount">
                    <div class="inactive-action-group">
                      <span class="inactive-status">
                        <i class="el-icon-warning-outline"></i>
                        {{ $t("machineUser.inactive") }}
                      </span>
                      <el-link
                        class="open-door-qr-link"
                        type="primary"
                        icon="el-icon-picture-outline"
                        @click="showOpenDoorQr(scope.row)"
                        >{{ $t("machineUser.openDoorQrCode") }}</el-link
                      >
                    </div>
                  </template>
                  <template v-else>
                    <el-link
                      class="open-door-qr-link"
                      type="primary"
                      icon="el-icon-picture-outline"
                      @click="showOpenDoorQr(scope.row)"
                      >{{ $t("machineUser.openDoorQrCode") }}</el-link
                    >
                    <el-link
                      type="primary"
                      icon="el-icon-s-goods"
                      v-hasPerm="['machine:line:product:update']"
                      @click="openDoorLineProduct(scope.row)"
                      >{{ $t("machineUser.lineProduct") }}</el-link
                    >
                    <el-link
                      type="primary"
                      icon="el-icon-bank-card"
                      v-hasPerm="['user:machine:payment']"
                      @click="payType(scope.row)"
                      >{{ $t("machineUser.payType") }}</el-link
                    >
                    <el-link
                      type="primary"
                      icon="el-icon-s-tools"
                      v-hasPerm="['user:equipment:config']"
                      @click="configUserMachine(scope.row)"
                      >{{ $t("machineUser.mConfig") }}</el-link
                    >
                    <el-link type="primary" icon="el-icon-picture-outline-round" @click="openAdvertConfig(scope.row)"
                      >{{ $t("machineUser.advertConfig") }}</el-link
                    >
                    <el-dropdown @command="handlerOpenDoorMore(scope.row, $event)">
                      <el-link type="primary" icon="el-icon-more">{{ $t("machineUser.moreActions") }}</el-link>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="info-edit">{{ $t("machineUser.editMachine") }}</el-dropdown-item>
                        <el-dropdown-item command="machine-position">{{ $t("machineUser.devicePosition") }}</el-dropdown-item>
                        <el-dropdown-item command="fast-config-machine">{{ $t("machineUser.yijianConfig") }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </div>
              </div>
            </template>
            <template v-else>{{ $t("machineUser.transfer") }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="userMachineList.length > 0">
        <el-pagination
          background
          layout="total,sizes,prev, pager, next,jumper"
          :current-page="page.pageIndex"
          :total="page.totalSize"
          :page-size="page.pageSize"
          @size-change="sizeChange"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      class="location-dialog"
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="addressDialogVisible"
      width="750px"
    >
      <span slot="title" class="dialog-title-left">Location Details</span>
      <div class="popup-form">
        <el-form :model="addressForm">
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Address</el-col>
            <el-col :span="17" class="popup-field">
              <el-autocomplete
                ref="addressAutocomplete"
                v-model="addressForm.location"
                :fetch-suggestions="querySearch"
                placeholder="Enter"
                @select="handleAddressSelect"
                style="width: 100%"
                popper-class="address-suggestion-dropdown"
              >
                <template slot="prefix">
                  <i class="el-icon-search ip-icon" style="margin-right: 4px"></i>
                </template>
                <template slot="suffix">
                  <i
                    v-if="addressForm.location"
                    class="el-icon-close ip-icon"
                    @click="clearAddress"
                    style="cursor: pointer"
                  ></i>
                </template>
                <template slot-scope="{ item }">
                  <div class="address-suggestion-item">
                    <span class="location-icon-bg">
                      <i class="el-icon-location"></i>
                    </span>
                    <div class="suggestion-text">
                      <div class="suggestion-title">{{ item.name }}</div>
                      <div class="suggestion-address">
                        <span v-if="item.county" style="color: #409eff; font-weight: 500; margin-right: 6px">{{
                          item.county
                        }}</span>
                        {{ item.address }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Contact Name</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.Contact" placeholder="Enter contact name" style="width: 100%"></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Phone Number</el-col>
            <el-col :span="17" class="popup-field">
              <el-input
                v-model="addressForm.PhoneNumber"
                placeholder="Enter phone number"
                style="width: 100%"
              ></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Email</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.email" placeholder="Enter email" style="width: 100%"></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Notes</el-col>
            <el-col :span="17" class="popup-field">
              <el-input
                type="textarea"
                v-model="addressForm.Notes"
                placeholder="Enter notes"
                :rows="3"
                style="width: 100%"
              ></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Install Date</el-col>
            <el-col :span="17" class="popup-field">
              <el-date-picker
                v-model="addressForm.Installed"
                type="date"
                placeholder="Select install date"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer-left">
        <el-button type="primary" @click="saveAddress">Save</el-button>
        <el-button @click="addressDialogVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import searchUserMachine from "_c/machine/user/SearchUserMachine";
  import editUserMachine from "_c/machine/user/EditUserMachine";
  import configUserMachine from "_c/machine/user/ConfigUserMachine";
  import openDoorLine from "_c/machine/user/OpenDoorLine";
  import userMachineMaps from "_c/machine/user/UserMachineMap";
  import payment from "_c/machine/user/Payment";
  import advertConfigDialog from "_c/adverts/AdvertConfigDialog";
  import { Loader } from "@googlemaps/js-api-loader";
  import eventBus from "@/utils/eventBus";
  export default {
    name: "MachineUser",
    components: {
      openDoorLine,
      userMachineMaps,
      editUserMachine,
      configUserMachine,
      searchUserMachine,
      payment,
      advertConfigDialog
    },
    data() {
      return {
        addressDialogVisible: false,
        addressForm: {
          name: "",
          location: "",
          lat: "",
          lng: ""
        },
        selectedMachine: null,
        loading: false,
        userMachineList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        search: {
          equipmentName: "",
          equipmentNo: "",
          userName: "",
          rentState: "",
          faultStatus: "",
          enableStatus: ""
        },
        form: {},
        multipleSelection: [],
        yesNo: [],
        ageDevice: [],
        feelLock: [],
        ageType: [],
        priorityMode: [],
        shuaKaQi: [],
        control: {
          remoteCode: "",
          remoteId: "",
          remoteStatus: 0,
          url: ""
        },
        userEquipment: {
          id: "",
          uid: "",
          equipmentNo: "",
          teamId: "",
          equipmentName: "",
          userFinanceId: "",
          userFinanceMachineGroupId: "",
          scene: "",
          servicePhone: "",
          enableStatus: "",
          locale: "",
          notes: "",
          isClose: "",
          isAgeFace: "0",
          modeType: "1",
          lineProductMode: "0",
          vatRate: {
            isSwitch: "0",
            proportion: 0,
            type: "1",
            enableStatus: "1"
          },
          config: {
            age: {}
          },
          lng: "",
          lat: ""
        },
        ConfigSubmit: {
          config: {
            info: {
              isPAd: null,
              isTAd: null,
              isPTag: null,
              isFaultClose: null,
              isCoupon: null,
              isEye: null,
              isPrivacy: null,
              privacy: "",
              isSms: null,
              isFaultLock: null,
              moneySign: "",
              isGoodsMode: null
            },
            manager: {
              isOpen: null,
              isDebug: null,
              passWord: ""
            },

            remote: {
              isBlue: null,
              blueType: null,
              isHaptic: null,
              hapticType: null
            },
            model: {
              type: null,
              lockPage: null,
              isPrompt: null,
              title: "",
              message: "",
              confirm: "",
              cancel: "",
              passWord: "",
              time: []
            },
            vatRate: {
              isOpen: null,
              isCalculating: null,
              type: null,
              proportion: null
            },
            shopping: {
              isTip: null,
              tipTitle: "",
              tipMessage: "",
              tipConfirm: "",
              tipCancel: "",
              isCart: null,
              cartNum: null
            },
            age: {
              isAge: null,
              ageCamera: null,
              ageQrCode: null,
              agePriority: null,
              ageDevice: "",
              isAgeFace: null,
              ageCount: null,
              ageSDK: null,
              faceSimilarity: null,
              isSecurity: null,
              isFace: null,
              time: [],
              ageRange: null
            },
            elock: {
              isOpen: null
            },
            advert: {
              isCountdown: null,
              countdown: ""
            }
          },
          equipmentNo: "",
          id: "",
          verify: [],
          walletPrice: ""
        },
        dialogUserMachine: false,
        dialogConfigMachine: false,
        showOpenDoorLine: false,
        openDoorMachine: {},
        dialogMachineMaps: false,
        dialogDeposit: false,
        machineGroup: [],
        uId: localStorage.getItem("uId"),
        pId: localStorage.getItem("pId"),
        userDeposit: {
          userName: "",
          nickName: "",
          equipmentNo: "",
          airwayBillNo: ""
        },
        selectList: [],
        dialogManage: false,
        nowRemoteInfo: {},
        nickName: "",
        dialogPayment: false,
        dialogAdvertConfig: false,
        payment: {
          equipmentNo: "",
          id: "",
          payConfig: {}
        },
        advertConfigMachine: {
          equipmentNo: "",
          equipmentName: ""
        },
        modeList: [],
        IdcardCountry: [],
        showOpenDoorQrCode: false,
        showOpenDoorQrLoading: false,
        openDoorQrCode: "",
        // 所有栏目可选项目
        allColumnsList: [
          {
            label: this.$t("machineUser.userName"),
            value: "userName"
          },
          {
            label: this.$t("machineUser.enableStatus"),
            value: "enableStatus"
          }
        ],
        nowAddColumns: [],
        isWarehouseAccount: false
      };
    },
    mounted() {
      this.getIdcardCountry();
      this.getYesNo();
      this.getShuaKaQi();
      this.listMachineGroup();
      this.listFinance();
      this.getAgeDevice();
      this.getFeelLock();
      this.getAgeType();
      this.getPriorityMode();
      this.warehouseAccountList();

      // 处理路由查询参数
      const query = this.$route.query;

      // 处理设备编号搜索
      if (query.equipmentNo) {
        this.search.equipmentNo = query.equipmentNo;
      }

      // 执行搜索
      this.currentChange();

      // Listen for address updates from Location.vue
      eventBus.on("machineAddressUpdated", this.handleAddressUpdatedFromLocation);
    },
    beforeDestroy() {
      // Clean up event listener
      eventBus.off("machineAddressUpdated", this.handleAddressUpdatedFromLocation);
    },
    computed: {
      rightWidth() {
        if (this.nowAddColumns && this.nowAddColumns.length < 4) {
          return 450;
        } else {
          return 365;
        }
      }
    },
    methods: {
      //方便仓库同事配置设备
      warehouseAccountList() {
        this.$api.dict("warehouse_account").then(res => {
          if (res.code === 0) {
            let warehouseAccount = localStorage.getItem("warehouseAccount");
            this.isWarehouseAccount = res.data.some(item => item.value === warehouseAccount);
          }
        });
      },
      openAdvertConfig(row) {
        this.advertConfigMachine = {
          equipmentNo: row.equipmentNo,
          equipmentName: row.equipmentName
        };
        this.dialogAdvertConfig = true;
      },
      handleAdvertConfigClose(dialog) {
        this.dialogAdvertConfig = dialog;
      },
      sortChange(column) {
        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      handlerChangeColumns(e) {
        this.nowAddColumns = e;
      },
      // 回收设备
      recoverMachine() {
        this.$confirm(this.$t("machine.recycle"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.userRecover, this.$method.put, {
              equipmentIds: this.$cloud.getIds(this.selectList)
            })
            .then(res => {
              let obj = JSON.parse(res.data);
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  dangerouslyUseHTMLString: true,
                  message: `number of successes:${obj.success}<br/>number of failures:${obj.error}<br/>${res.msg}`,
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      },
      // 解锁
      handleUnlock(row) {
        this.$confirm(this.$t("common.gzsptip"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            this.$api
              .request(this.$url.UserMachine.update, this.$method.put, {
                teamId: row.teamId,
                id: row.id,
                isLock: 0
              })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.$t("common.unlockcg"),
                    type: "success"
                  });
                }
                this.loading = false;
                this.pageIndex = 1;
                this.currentChange();
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      },
      tableRowClassName({ row }) {
        if (row.enableStatus == 0) {
          return "warning-row";
        }
      },
      handleSelectionChange(val) {
        this.selectList = val;
      },
      listFinance() {
        this.$api.dict("gp_user_machine_mode").then(res => {
          this.modeList = res.data;
        });
      },
      getIdcardCountry() {
        this.$api.dict("sys_idcard_country").then(res => {
          if (res.code === 0) {
            this.IdcardCountry = res.data;
          }
        });
      },
      getYesNo() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            this.yesNo = res.data;
          }
        });
      },
      getAgeDevice() {
        this.$api.dict("age_device").then(res => {
          if (res.code === 0) {
            this.ageDevice = res.data;
          }
        });
      },
      getFeelLock() {
        this.$api.dict("feel_lock").then(res => {
          if (res.code === 0) {
            this.feelLock = res.data;
          }
        });
      },
      getAgeType() {
        this.$api.dict("age_discern_type").then(res => {
          if (res.code === 0) {
            this.ageType = res.data;
          }
        });
      },
      getPriorityMode() {
        this.$api.dict("priority_mode").then(res => {
          if (res.code === 0) {
            this.priorityMode = res.data;
          }
        });
      },
      getShuaKaQi() {
        this.$api.dict("sys_shua_kaqi").then(res => {
          if (res.code === 0) {
            this.shuaKaQi = res.data;
          }
        });
      },
      listMachineGroup() {
        this.$api.request(this.$url.UserMachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        let _self = this;

        _self.page.pageIndex = pageIndex ? pageIndex : 1;

        _self.loading = true;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        _self.$api
          .request(_self.$url.UserMachine.page, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              let records = res.data.records;

              for (let i = 0; i < records.length; i++) {
                let isshow = false;
                if (records[i]["userFinanceId"] == _self.uId && !isshow) {
                  isshow = true;
                }
                records[i]["isshow"] = isshow;
              }

              _self.userMachineList = res.data.records;
              _self.page.totalSize = parseInt(res.data.total);

              // Load notes data for all machines to get addresses
              _self.loadNotesForAllMachines();
            }
            _self.loading = false;
          })
          .catch(() => {
            _self.loading = false;
          });
      },

      async loadNotesForAllMachines() {
        const promises = this.userMachineList.map(async machine => {
          try {
            const response = await this.$api.request(this.$url.Notes.getByMachineNo, this.$method.get, {
              machineNo: machine.equipmentNo
            });

            if (response.code === 0 && response.data) {
              // Update the machine in the list with address from notes
              const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
              if (machineIndex !== -1) {
                const newAddress = response.data.address || response.data.locale || response.data.location || "";
                // Always update the locale field, even if it's empty/null
                this.$set(this.userMachineList, machineIndex, {
                  ...this.userMachineList[machineIndex],
                  locale: newAddress || null // Set to null if empty string
                });
              }
            } else if (response.code === 0 && !response.data) {
              // If no notes data found, ensure locale is null
              const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
              if (machineIndex !== -1) {
                this.$set(this.userMachineList, machineIndex, {
                  ...this.userMachineList[machineIndex],
                  locale: null
                });
              }
            }
          } catch (error) {
            // On error, set locale to null
            const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
            if (machineIndex !== -1) {
              this.$set(this.userMachineList, machineIndex, {
                ...this.userMachineList[machineIndex],
                locale: null
              });
            }
          }
        });

        await Promise.all(promises);
        // Force Vue to re-render the component to show updated addresses
        this.$forceUpdate();
      },

      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      faultStatus(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.faultStatus);
      },
      isPort(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.port);
      },
      enableStatus(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.enableStatus);
      },
      isDebug(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.info.isDebug);
      },
      isRemoteControl(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.remote.isBlue);
      },
      isFeelControl(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.remote.isHaptic);
      },
      isDoubleScreen(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isDoubleScreen);
      },
      isLock(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isLock);
      },
      isSms(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.info.isSms);
      },
      isCart(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isCart);
      },
      openDoorLineProduct(row) {
        this.openDoorMachine = JSON.parse(JSON.stringify(row));
        this.openDoorMachine.id = row.id;
        this.showOpenDoorLine = true;
      },
      handlerCloseOpenDoorLine() {
        this.showOpenDoorLine = false;
      },
      showOpenDoorQr(row) {
        this.showOpenDoorQrCode = true;
        this.showOpenDoorQrLoading = true;
        this.openDoorQrCode = "";
        this.$api
          .request(this.$url.OpenDoor.getQrCodeConfig, this.$method.get, {
            userEquipmentId: row.id
          })
          .then(res => {
            if (res.code !== 0) {
              this.$message.warning(res.msg || "二维码获取失败");
              return;
            }
            const data = res.data || {};
            this.openDoorQrCode = data.qrCode || data.openDoorQrCode || data.url || data.imgUrl || "";
            if (!this.openDoorQrCode) {
              this.$message.warning("未查询到二维码");
            }
          })
          .finally(() => {
            this.showOpenDoorQrLoading = false;
          });
      },
      handlerOpenDoorMore(row, command) {
        if (command === "info-edit") {
          this.editUserMachine(row);
          return;
        }
        if (command === "machine-position") {
          this.machineMaps(row);
          return;
        }
        if (command === "fast-config-machine") {
          this.handleConfig(row);
        }
      },
      handleConfig(row) {
        this.$confirm(this.$t("machineUser.warnConfig"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api
              .request(this.$url.UserMachine.config, this.$method.post, {
                id: row.id
              })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.currentChange(this.page.pageIndex);
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          })
          .catch(() => {});
      },
      editUserMachine(row) {
        // 创建深拷贝，避免污染表格数据
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
        this.dialogUserMachine = true;
      },
      configUserMachine(row) {
        // 创建深拷贝，避免污染表格数据
        this.ConfigSubmit.config = JSON.parse(JSON.stringify(row.config));
        this.ConfigSubmit.userEquipmentOpenDoorDTO = row.userEquipmentOpenDoorDTO
          ? JSON.parse(JSON.stringify(row.userEquipmentOpenDoorDTO))
          : {};
        this.ConfigSubmit.equipmentNo = row.equipmentNo;
        this.ConfigSubmit.id = row.id;
        this.ConfigSubmit.verify = row.verify ? JSON.parse(JSON.stringify(row.verify)) : [];
        this.ConfigSubmit.walletPrice = row.walletPrice;
        this.dialogConfigMachine = true;
      },

      handleControl(item) {
        let _self = this;
        this.nowRemoteInfo = item;
        const loading = _self.$loading({
          lock: true,
          text: _self.$t("common.ljload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        _self.$api
          .request(_self.$url.UserMachine.control, _self.$method.post, {
            equipmentNo: item.equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              // 还原次数
              _self.countError = 0;
              //  监听远程控制连接状态
              _self.getYCKZControl(item.equipmentNo, loading);
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      // 延迟函数
      async delay(time) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, time);
        });
      },
      //  监听远程控制连接状态
      async getYCKZControl(equipmentNo, loading) {
        let _self = this;
        await this.delay(3000);
        // 调用一次++
        this.countError++;
        if (this.countError > 20) {
          this.$message.warning(this.$t("user.MachineMaps.588934-10"));
          loading.close();
          if (!(this.nowRemoteInfo.remoteCode && this.nowRemoteInfo.remoteId && this.nowRemoteInfo.gotoHttpUrl)) {
            //超时
            return;
          }
          this.control.remoteCode = this.nowRemoteInfo.remoteCode;
          this.control.remoteId = this.nowRemoteInfo.remoteId;
          this.control.url = this.nowRemoteInfo.gotoHttpUrl;
          let djs = setTimeout(function () {
            clearTimeout(djs);
            _self.$refs.btnForm.click();
          }, 1000);
          return;
        }
        //  执行连接状态检测
        _self.$api
          .request(_self.$url.UserMachine.getcontrol, _self.$method.get, {
            equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              if (res.data && res.data.remoteState == 2) {
                loading.close();
                //  连接成功
                _self.control.remoteCode = res.data.remoteCode;
                _self.control.remoteId = res.data.remoteId;
                _self.control.url = res.data.gotoHttpUrl;
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.$refs.btnForm.click();
                }, 1000);
                return;
              } else if (res.data && res.data.remoteState == -1) {
                loading.close();
                _self.$notify({
                  title: _self.$t("common.tip"),
                  message: _self.$t("common.ljfail"),
                  type: "error"
                });
              } else {
                //  休息1秒
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.getYCKZControl(equipmentNo, loading);
                }, 1000);
              }
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: JSON.stringify(res),
              type: "error"
            });
          });
      },
      // 弹出地图弹框
      machineMaps(row) {
        this.dialogMachineMaps = true;
        // 创建深拷贝，避免污染表格数据
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
      },
      // 隐藏地图弹框
      mapsCancel(dialog, state) {
        this.dialogMachineMaps = dialog;
      },
      // Handle address updates from UserMachineMap component
      handleAddressUpdated(addressData) {
        // Update the machine in the userMachineList
        const machineIndex = this.userMachineList.findIndex(machine => machine.equipmentNo === addressData.machineNo);

        if (machineIndex !== -1) {
          // Update the machine with new address data
          this.$set(this.userMachineList, machineIndex, {
            ...this.userMachineList[machineIndex],
            locale: addressData.address,
            lat: addressData.lat,
            lng: addressData.lng
          });

          // Also update the Notes table to keep everything in sync
          this.updateNotesAddress(addressData);

          // Force Vue to re-render the component
          this.$forceUpdate();

          // Notify Location.vue component to refresh its data
          eventBus.emit("machineAddressUpdated", addressData);

          // Show success message
          this.$notify({
            title: this.$t("common.tip"),
            message: "Address updated successfully",
            type: "success"
          });
        }
      },

      // Handle address updates from Location.vue component
      handleAddressUpdatedFromLocation(addressData) {
        // Update the machine in the userMachineList
        const machineIndex = this.userMachineList.findIndex(machine => machine.equipmentNo === addressData.machineNo);

        if (machineIndex !== -1) {
          // Update the machine with new address data
          this.$set(this.userMachineList, machineIndex, {
            ...this.userMachineList[machineIndex],
            locale: addressData.address,
            lat: addressData.lat,
            lng: addressData.lng
          });

          // Force Vue to re-render the component
          this.$forceUpdate();
        }
      },

      // Update Notes table with new address from UserMachineMap
      updateNotesAddress(addressData) {
        // Find the machine to get its notes data
        const machine = this.userMachineList.find(m => m.equipmentNo === addressData.machineNo);
        if (!machine) {
          return;
        }

        // Prepare notes update payload
        const notesUpdatePayload = {
          machineNo: addressData.machineNo,
          machineId: addressData.machineId || machine.id,
          address: addressData.address,
          lat: addressData.lat || "",
          lng: addressData.lng || "",
          contactName: machine.notesData?.contactName || "",
          phoneNumber: machine.notesData?.phoneNumber || "",
          email: machine.notesData?.email || "",
          notesContent: machine.notesData?.notesContent || "",
          installDate: machine.notesData?.installDate || ""
        };

        // Update the notes table
        this.$api
          .request(this.$url.Notes.updateByMachineNo, this.$method.put, notesUpdatePayload)
          .then(res => {
            if (res?.code === 0) {
              // Update the machine's notesData with the new address
              const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === addressData.machineNo);
              if (machineIndex !== -1) {
                this.$set(this.userMachineList, machineIndex, {
                  ...this.userMachineList[machineIndex],
                  notesData: {
                    ...this.userMachineList[machineIndex].notesData,
                    address: addressData.address,
                    lat: addressData.lat,
                    lng: addressData.lng
                  }
                });
              }
            }
          })
          .catch(() => null);
      },

      payType(row) {
        this.dialogPayment = true;
        // 创建深拷贝，避免污染表格数据
        this.payment = {
          equipmentNo: row.equipmentNo,
          id: row.id,
          payConfig: row.payConfig ? JSON.parse(JSON.stringify(row.payConfig)) : {}
        };
      },
      cancel(dialog, state) {
        this.dialogUserMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      configCancel(dialog, state) {
        this.dialogConfigMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      // 批量管理
      batchManage() {
        this.dialogManage = true;
      },

      // Open address dialog when clicking on address link
      openAddressDialog(row) {
        this.selectedMachine = row;

        this.addressForm.location = row.locale || "";
        this.addressForm.machineNo = row.equipmentNo || "";

        //   location: this.addressForm.location,
        //   machineNo: this.addressForm.machineNo
        // });

        this.getNotesByMachineNo(row.equipmentNo);
        this.addressDialogVisible = true;
      },

      getNotesByMachineNo(machineNumber) {
        let _self = this;
        return _self.$api
          .request(_self.$url.Notes.getByMachineNo, _self.$method.get, {
            machineNo: machineNumber
          })
          .then(res => {
            if (res?.code === 0 && res?.data) {
              this.addressForm = {
                ...this.addressForm,
                machineNo: this.addressForm.machineNo, // Explicitly preserve machineNo
                location: res.data.address || res.data.locale || this.addressForm.location,
                Contact: res.data.contactName || "",
                PhoneNumber: res.data.phoneNumber || "",
                email: res.data.email || "",
                Notes: res.data.notesContent || "",
                Installed: res.data.installDate || ""
              };
            }
            return Promise.resolve();
          })
          .catch(() => Promise.resolve());
      },

      // Handle address search suggestions
      querySearch(queryString, cb) {
        if (!queryString) {
          cb([]);
          return;
        }
        const loader = new Loader({
          apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
          version: "weekly",
          libraries: ["places"]
        });
        loader.load().then(google => {
          const autocompleteService = new google.maps.places.AutocompleteService();
          const placesService = new google.maps.places.PlacesService(document.createElement("div"));
          autocompleteService.getPlacePredictions(
            {
              input: queryString,
              types: ["establishment", "geocode"],
              componentRestrictions: { country: "us" }
            },
            (predictions, status) => {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                cb([]);
                return;
              }
              // For each prediction, fetch full address
              const fetchDetails = predictions.map(prediction => {
                return new Promise(resolve => {
                  placesService.getDetails(
                    {
                      placeId: prediction.place_id,
                      fields: ["name", "formatted_address", "address_components", "geometry"]
                    },
                    (place, status) => {
                      let county = "";
                      let lat = "";
                      let lng = "";
                      if (status === google.maps.places.PlacesServiceStatus.OK && place) {
                        if (place.address_components) {
                          const countyComp = place.address_components.find(comp =>
                            comp.types.includes("administrative_area_level_2")
                          );
                          if (countyComp) {
                            county = countyComp.long_name;
                            county = county.replace(/\s*County$/i, "").trim();
                          }
                        }
                        if (place.geometry && place.geometry.location) {
                          lat = place.geometry.location.lat();
                          lng = place.geometry.location.lng();
                        }

                        resolve({ name: place.name, address: place.formatted_address, county, lat, lng });
                      } else {
                        resolve({
                          name: prediction.structured_formatting.main_text,
                          address: prediction.structured_formatting.secondary_text || prediction.description,
                          county: "",
                          lat: "",
                          lng: ""
                        });
                      }
                    }
                  );
                });
              });
              Promise.all(fetchDetails).then(results => {
                cb(results);
              });
            }
          );
        });
      },

      // Handle address selection from suggestions
      handleAddressSelect(item) {
        this.addressForm.location = item.address;
        this.addressForm.lat = item.lat;
        this.addressForm.lng = item.lng;
      },

      // Clear address input
      clearAddress() {
        this.addressForm.location = "";
        this.addressForm.lat = null;
        this.addressForm.lng = null;
      },

      // Clean address to remove duplication pattern
      cleanAddress(address) {
        if (!address) return address;

        // Pattern to match: "Street Name, County, Street Name, City, State, ZIP, Country"
        // Example: "7921 Simon Ave, Cuyahoga, 7921 Simon Ave, Cleveland, OH 44103, USA"
        // More flexible pattern to handle various formats
        const duplicatePattern = /^(.+?),\s*([^,]+),\s*\1,\s*(.+)$/;
        const match = address.match(duplicatePattern);

        if (match) {
          // Return: "Street Name, City, State, ZIP, Country"
          const cleaned = `${match[1]}, ${match[3]}`;
          return cleaned;
        }

        return address;
      },

      // Save address
      async saveAddress() {
        if (!this.addressForm.location) {
          this.$message.warning("Please enter an address");
          return;
        }

        // If coordinates are missing, geocode the address
        let lat = this.addressForm?.lat || "";
        let lng = this.addressForm?.lng || "";

        if (!lat || !lng) {
          try {
            const coordinates = await this.geocodeAddress(this.addressForm.location);
            if (coordinates) {
              lat = coordinates.lat;
              lng = coordinates.lng;
            }
          } catch (error) {
            this.$message.warning(
              "Could not get coordinates for the address. The address will be saved without map coordinates."
            );
          }
        }

        const addressPayload = {
          address: this.addressForm?.location,
          lat: lat,
          lng: lng,
          machineNo: this.addressForm.machineNo
        };

        try {
          // Find the machine to get its ID
          const machine = this.userMachineList.find(m => m.equipmentNo === this.addressForm.machineNo);
          if (!machine) {
            this.$message.error("Machine not found");
            return;
          }

          // Update both the main machine data AND the notes table for synchronization
          const machineUpdatePayload = {
            id: machine.id,
            teamId: machine.teamId, // Preserve teamId to prevent machine group from being removed
            locale: this.addressForm.location,
            lat: lat,
            lng: lng
          };

          const notesUpdatePayload = {
            machineNo: this.addressForm.machineNo,
            machineId: machine.id,
            address: this.addressForm.location,
            lat: lat,
            lng: lng,
            contactName: this.addressForm.Contact || "N/A",
            phoneNumber: this.addressForm.PhoneNumber || "",
            email: this.addressForm.email || "",
            notesContent: this.addressForm.Notes || "",
            installDate: this.addressForm.Installed || ""
          };

          // Update both APIs simultaneously
          const [machineRes, notesRes] = await Promise.all([
            this.$api.request(this.$url.UserMachine.update, this.$method.put, machineUpdatePayload),
            this.$api.request(this.$url.Notes.updateByMachineNo, this.$method.put, notesUpdatePayload)
          ]);

          if (machineRes?.code === 0 && notesRes?.code === 0) {
            this.$message.success("Address updated successfully");
            this.addressDialogVisible = false;
            this.currentChange(); // Refresh the table

            // Refresh the data from server to ensure all locations are synchronized
            setTimeout(() => {
              this.currentChange(); // Reload all machine data from server
            }, 1000);
          } else {
            this.$message.error(machineRes?.msg || notesRes?.msg || "Failed to update address");
          }
        } catch (error) {
          this.$message.error("Failed to update address");
        }
      },

      // Geocode an address to get coordinates
      geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          if (!address) {
            reject(new Error("No address provided"));
            return;
          }

          const loader = new Loader({
            apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
            version: "weekly",
            libraries: ["places"]
          });

          loader
            .load()
            .then(google => {
              const geocoder = new google.maps.Geocoder();

              geocoder.geocode({ address: address }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                  const location = results[0].geometry.location;
                  const coordinates = {
                    lat: location.lat(),
                    lng: location.lng()
                  };
                  resolve(coordinates);
                } else {
                  reject(new Error(`Geocoding failed: ${status}`));
                }
              });
            })
            .catch(error => {
              reject(error);
            });
        });
      },

      async saveNotesData() {
        try {
          const notesPayload = {
            machineNo: this.addressForm.machineNo,
            machineId: this.selectedMachine?.id || "",
            contactName: this.addressForm.Contact || "N/A",
            phoneNumber: this.addressForm.PhoneNumber || "",
            email: this.addressForm.email || "",
            address: this.addressForm?.location || "",
            lng: this.addressForm?.lng || "",
            lat: this.addressForm?.lat || "",
            notesContent: this.addressForm.Notes || "",
            installDate: this.addressForm.Installed || ""
          };

          const response = await this.$api.request(this.$url.Notes.updateByMachineNo, this.$method.put, notesPayload);

          if (response.code === 0) {
            // Notes data saved successfully
          }
        } catch (error) {
          // Error saving notes data
        }
      },

      cancelManage(dialog, state) {
        this.dialogManage = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      selectable(row) {
        return row.rentState != 1 || this.uId == row.uId;
      },
      // 支付方式弹框关闭
      cancelPayment(dialog, state) {
        this.dialogPayment = dialog;
        if (state) {
          const page = this.page.pageIndex;
          this.currentChange(page);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .machine-user {
    height: 100%;
    overflow: hidden;
  }
  .btn {
    display: inline-block;
    background-color: #02a7f0;
    color: white;
    padding: 10px 0;
    text-align: center;
    border-radius: 6px;
    width: 45%;
    cursor: pointer;
  }
  ::v-deep .el-table th {
    padding: 8px 0;
  }
  .table {
    overflow: visible;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .table .el-table .warning-row {
    background: #f56c6c;
    color: #ffffff;
  }
  .table .el-table .hover-row {
    color: #606266;
  }
  .machine-user .image {
    position: absolute;
  }
  .machine-user .maturity {
    color: #f56c6c;
  }
  .machine-user .renew {
    color: #67c23a;
  }
  .inactive-status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #f56c6c;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }
  .open-door-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px 12px;
    line-height: 30px;
  }
  .inactive-action-group {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
  .open-door-qr-link {
    font-weight: 600;
  }
  .dialog-title-left {
    display: block;
    text-align: left;
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-left: 4px;
  }

  .address-suggestion-dropdown {
    min-width: 350px;
  }

  .address-suggestion-item {
    display: flex;
    align-items: flex-start;
    /* align icon and text at the top */
    padding: 6px 10px;
  }

  .location-icon-bg {
    flex: 0 0 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f6fa;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-right: 10px;
  }

  .location-icon-bg .el-icon {
    font-size: 18px;
    color: #409eff;
  }

  .suggestion-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .suggestion-title,
  .suggestion-address {
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    /* max 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    white-space: normal;
    /* allow wrapping but clamp */
  }

  .suggestion-title {
    font-weight: 600;
    font-size: 14px;
    color: #222;
    margin-bottom: 2px;
    line-height: 1.4;
  }

  .suggestion-address {
    font-size: 12px;
    color: #666;
    line-height: 1.3;
  }
  .ip-icon {
    margin-top: 13px;
  }

</style>
